import { useEffect, useMemo, useState } from "react"
import { Form, InputGroup } from "react-bootstrap"

const versionRegex = /^\d+$/,
    tagRegex = /^[0-9A-Za-z-.]*$/

export const FirmwareVersionInput = ({ initialVersion, setVersion, children }) => {
    const init = splitVersion(initialVersion)

    const [majorText, major, majorValid, setMajor] = useVersionDigit(init[0])
    const [minorText, minor, minorValid, setMinor] = useVersionDigit(init[1])
    const [patchText, patch, patchValid, setPatch] = useVersionDigit(init[2])

    const [tag, setTag] = useState(init[3] ?? "")
    const tagValid = useMemo(() => tagRegex.test(tag), [tag])

    const version = useMemo(
        () => (tag ? `${major}.${minor}.${patch}-${tag}` : `${major}.${minor}.${patch}`),
        [major, minor, patch, tag]
    )
    const versionValid = useMemo(
        () => majorValid && minorValid && patchValid && tagValid && major + minor + patch > 0,
        [majorValid, minorValid, patchValid, tagValid, major, minor, patch]
    )

    useEffect(() => setVersion?.(versionValid ? version : ""), [setVersion, versionValid, version])

    return (
        <InputGroup>
            <Form.Control
                isInvalid={!majorValid}
                style={{ maxWidth: "120px" }}
                type="number"
                placeholder="major"
                min={0}
                step={1}
                value={majorText}
                onChange={(e) => setMajor(e.target.value)}
            />
            <Form.Control
                isInvalid={!minorValid}
                style={{ maxWidth: "120px" }}
                type="number"
                placeholder="minor"
                min={0}
                step={1}
                value={minorText}
                onChange={(e) => setMinor(e.target.value)}
            />
            <Form.Control
                isInvalid={!patchValid}
                style={{ maxWidth: "120px" }}
                type="number"
                placeholder="patch"
                min={0}
                step={1}
                value={patchText}
                onChange={(e) => setPatch(e.target.value)}
            />
            <Form.Control
                isInvalid={!tagValid}
                type="text"
                placeholder="tag"
                value={tag}
                onChange={(e) => setTag(e.target.value)}
            />
            <InputGroup.Text>{version}</InputGroup.Text>
            {children}
        </InputGroup>
    )
}

const splitVersion = (str) => {
    const numParts = str?.split(".")
    if (numParts?.length !== 3) {
        return []
    }
    const tagParts = numParts?.[2]?.split("-")
    return [numParts[0], numParts[1], tagParts[0], tagParts[1]]
}

const useVersionDigit = (def) => {
    const [digit, setDigit] = useState(def ?? "")
    const [noChange, setNoChange] = useState(true)
    const valid = useMemo(() => noChange || versionRegex.test(digit), [noChange, digit])

    useEffect(() => {
        if (digit) {
            setNoChange(false)
        }
    }, [digit])

    return [digit, digit || "x", valid, setDigit]
}
